import { outdent } from 'outdent';

const BLOCKS_WIDGET_HMR_PARAMETER = 'blocks-widget-hmr';
export const BLOCKS_WIDGET_HMR_RE = new RegExp(
  `[?&]${BLOCKS_WIDGET_HMR_PARAMETER}(=([^&]+))?`
);
export const getBlocksWidgetHMRTemplate = (id: string, root: string) => {
  const originalId = id.replace(BLOCKS_WIDGET_HMR_RE, '').replace(root, '');

  return outdent`
    if (import.meta.hot) {
      // We catch HMR updates because otherwise Vite reloads the component as a fallback
      import.meta.hot.accept((_) => {});

      import.meta.hot.accept(
        '${originalId}',
        async (newModule, ...args) => {
          const { data } = import.meta.hot;
          data.onHMR?.();
          data.controllerModule = newModule;
          return await data.controllerModule.default?.(...data.arguments);
        }
      );
    }

    export default async(onHMRCallback, ...args) => {
      const { data } = import.meta.hot;
      data.onHMR = onHMRCallback
      data.arguments = args;
      if (!data.controllerModule) {
        data.controllerModule = await import('${originalId}');
      }
      return await data.controllerModule.default?.(...args);
    }
  `;
};
// Note that parameterName should have valid variable syntax, like widgetId or widget_id.
// Names like widget-id are not valid and will break runtime code.
export const getBlocksPathWithHMR = (
  relativePath: string,
  parameterName?: string
) =>
  parameterName
    ? `/${relativePath}?${BLOCKS_WIDGET_HMR_PARAMETER}`
    : `/${relativePath}?${BLOCKS_WIDGET_HMR_PARAMETER}=\${${parameterName}}`;
